import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

import { SecurityService } from '../services/security.service';
import { AppConfigService } from '../services/app-config.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private securityService: SecurityService,
    private env: AppConfigService,
    private router: Router
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const user = this.securityService.user;
    const token: string = user?.access_token;

    let customHeaders: HttpHeaders = request.headers;
    let customWithCredentials = request.withCredentials;
    let customUrl = request.url;

    if (token) {
      customHeaders = customHeaders.set('Authorization', `Bearer ${token}`);
    }

    if (request.url.startsWith('/')) {

      if (request.body) {
        if (request.body instanceof FormData) {
          customHeaders = customHeaders.delete('Content-Type');
        } else if (!customHeaders.has('Content-Type')) {
          customHeaders = customHeaders.set('Content-Type', 'application/json');
        }
      }
      customWithCredentials = false;
      customUrl = `${this.env.config.gatewayUrl}${request.url}`;
    }

    request = request.clone(
      {
        headers: customHeaders,
        withCredentials: customWithCredentials,
        url: customUrl
      });

    return next.handle(request).pipe(tap(() => { },
      async (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }
          if (!request.url.includes('/authenticate/login')) {
            await this.securityService.logout();
          }
          this.router.navigate(['accounts/login'], { queryParams: { statusCode: err.status } });
        }
      }));
  }
}
